import React, { createContext, useContext, useState } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import ProtectedRoute from '../auth/ProtectedRoute';
import RideHome from './RideHome';
import RideSelect from './RideSelect';
import RideTracking from './RideTracking';
import RideRides from './RideRides';
import RideAccount from './RideAccount';
import RideDrawer from './RideDrawer';
import '../../css/ride.css';

const RideShellContext = createContext({ openMenu: () => {} });
export const useRideShell = () => useContext(RideShellContext);

/**
 * App shell for the Yango-style ride experience. Mounted at /ride/* and
 * hidden from the marketing/transport chrome (no Header/Footer/Container).
 */
export default function RideApp() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <RideShellContext.Provider value={{ openMenu: () => setMenuOpen(true) }}>
      <div className="ride-app">
        <Routes>
          <Route index element={<RideHome />} />
          <Route
            path="select"
            element={
              <ProtectedRoute>
                <RideSelect />
              </ProtectedRoute>
            }
          />
          <Route
            path="track/:id"
            element={
              <ProtectedRoute>
                <RideTracking />
              </ProtectedRoute>
            }
          />
          <Route
            path="rides"
            element={
              <ProtectedRoute>
                <RideRides />
              </ProtectedRoute>
            }
          />
          <Route
            path="account"
            element={
              <ProtectedRoute>
                <RideAccount />
              </ProtectedRoute>
            }
          />
          <Route path="*" element={<Navigate to="/ride" replace />} />
        </Routes>
        <RideDrawer open={menuOpen} onClose={() => setMenuOpen(false)} />
      </div>
    </RideShellContext.Provider>
  );
}
